<template>
    <div>
        <div class="dropzone">
            <span v-if="!uploading" class="dropzone__message">{{$t(dropzoneMessage)}}</span>
            <span v-if="uploading" class="dropzone__message">{{$t(dropzoneMessage)}}</span>
            <input v-if="!uploading" type="file" accept="acceptMime" class="file__input__hidden" name="documentUpload" ref="documentUpload" @change="$emit('fileSelectedEvent', $event)">
        </div>

        <div>{{$t('common.or')}}</div>

        <loading-button @submited="$refs.documentUpload.click()" :loading="uploading" :text="$t(buttonText)"></loading-button>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { Component, Prop } from 'vue-property-decorator';
    import LoadingButton from '@/components/general/LoadingButton';

    @Component({
        components: {
            LoadingButton,
        }
    })
    export default class DropzoneWithLoadingButton extends Vue {
        name = 'dropzone-with-loading-button';

        @Prop() uploading;

        @Prop({ default: '.pdf, .doc, .docx, .png, .jpg, .jpeg, .bmp, .gif'}) acceptMime;
        @Prop({ default: 'modals.upload_document.dropzone_default_message' }) dropzoneMessage;
        @Prop({ default: 'common.choose_file' }) buttonText;

    }

</script>



// WEBPACK FOOTER //
// src/components/general/DropzoneWithLoadingButton.vue